module.exports = __webpack_public_path__ + "img/1.6817f039.jpg";